import { CornerUpLeft } from 'lucide-react';

interface Props {
  /** Anzeigename des zuletzt Sprechenden (null = bisher niemand). */
  targetName: string | null;
  /** Spricht dieses Ziel GERADE mit uns? → hervorheben. */
  speaking: boolean;
}

/**
 * Oberste Zeile im Panel: reine REMOTE-ANZEIGE, wer zuletzt gesprochen hat.
 * Bewusst KEIN Audio-Button – sonst würde das Audio doppelt reinkommen (man
 * hört die Gegenstelle bereits über die normale Taste). Leuchtet auf, während
 * die Gegenstelle gerade spricht.
 */
export function ReplyButton({ targetName, speaking }: Props): JSX.Element {
  const has = !!targetName;
  return (
    <div
      className={[
        'w-full rounded-btn border px-3 py-3 flex items-center gap-3 select-none transition-colors',
        speaking
          ? 'bg-[#5a1414] border-[#ef4444] text-white animate-pulse-amber'
          : has
          ? 'bg-elev border-border text-text'
          : 'bg-elev/50 border-border text-text-mute',
      ].join(' ')}
      aria-live="polite"
    >
      <CornerUpLeft size={18} className="shrink-0 opacity-80" />
      <div className="flex flex-col items-start min-w-0">
        <span className="text-[0.6rem] uppercase tracking-wider opacity-60 leading-none">
          {speaking ? 'Spricht gerade' : 'Zuletzt gesprochen'}
        </span>
        <span className="text-lg font-bold leading-tight truncate w-full">{targetName ?? '—'}</span>
      </div>
    </div>
  );
}
